import { useTranslation } from 'react-i18next'

import { formatNumberWithSeparators } from '../../../../utils/number'
import { Divider } from '../../../Divider'
import { FormikField } from '../../../Formik'
import { IntegerInput } from '../../../Input'
import { SettingsCompactField, SettingsSection } from '../../../Settings'
import {
  CALENDAR_SETTINGS_DAILY_LIMIT_MAX,
  CALENDAR_SETTINGS_DAILY_LIMIT_MIN,
  CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT,
  QA_NAME_CALENDAR_SETTINGS_DUE_DATES,
} from '../../CalendarSettings.constants'

import * as styles from './DueDatesSection.module.css'

function DueDatesSection({ isLoading }) {
  const { t } = useTranslation()

  return (
    <>
      <Divider />
      <SettingsSection
        descriptionKey='CalendarSettings.DueDatesSectionDescriptionKey'
        qaName={QA_NAME_CALENDAR_SETTINGS_DUE_DATES}
        titleKey='CalendarSettings.DueDatesSectionTitleKey'
      >
        <div className={styles.body}>
          {isLoading ? (
            <SettingsCompactField isLoading className={styles.fieldSkeleton} />
          ) : (
            <FormikField
              Component={IntegerInput}
              Field={SettingsCompactField}
              emptyValue={null}
              fieldComponentProps={{
                labelKey: 'CalendarSettings.DailyLimitKey',
              }}
              max={CALENDAR_SETTINGS_DAILY_LIMIT_MAX}
              min={CALENDAR_SETTINGS_DAILY_LIMIT_MIN}
              name={CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT}
              placeholder={t('CalendarSettings.DailyLimitPlaceholderKey')}
              transformValue={formatNumberWithSeparators}
            />
          )}
        </div>
      </SettingsSection>
    </>
  )
}

export default DueDatesSection
